import { formatActivityDateTime } from "./formatActivityDateTime";
import { partnerBookingStatusConfig } from "./bookingStatus";
import type { BookingListRow } from "./bookingViewModel";

export type PartnerVisitDateTimeLabels = {
  dateLabel: string | null;
  shortDateLabel: string | null;
  timeLabel: string | null;
};

export function getPartnerVisitDateTimeLabels(
  booking: BookingListRow,
): PartnerVisitDateTimeLabels {
  if (booking.visitAt) {
    const labels = formatActivityDateTime(
      booking.visitAt,
      booking.activityRegionCode,
      undefined,
      { timeOnly: true },
    );
    if (labels) {
      return {
        dateLabel: labels.dateLabel,
        shortDateLabel: labels.shortDateLabel,
        timeLabel: labels.timeLabel,
      };
    }
  }
  const slot = booking.timeSlot?.trim();
  return {
    dateLabel: null,
    shortDateLabel: null,
    timeLabel: slot || null,
  };
}

export function getPartnerBookingCardPresentation(booking: BookingListRow) {
  const partnerTone = partnerBookingStatusConfig(
    booking.status,
    booking.handshakeStatus,
  );

  return {
    statusAccent: partnerTone.cardBorderClass,
    titleMuted: partnerTone.settleCard,
    highlightCard: Boolean(partnerTone.highlightCard),
  };
}
